import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { BuildingConfig } from "../../data";

@Component({
    selector: "app-navigation-button",
    templateUrl: "./navigation-button.component.html",
    styleUrl: "./navigation-button.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavigationButtonComponent {
  private router = inject(Router);

  public config = input.required<BuildingConfig>();

  public navigate() {
    this.router.navigate([`/${this.config().routePath}`], {
      queryParamsHandling: "merge",
    });
  }
}
